import { ArticleArea } from "../../../Styling/Layout/ContentArea"
import { QRCodeCanvas } from "qrcode.react";
import { Container, Col, Form } from "react-bootstrap";
import { BfButtonBlue, BfFormControl, BfFormLabel, BfTightYellowRowForm, BfYellowRowForm, YellowRoundedContainer } from "../../../Styling/styledForm/styledBlueForm";
import { useState } from "react";

export const DisplayQrCode = (props) => {

    let messages = props.messages
    let url = props.qrCodeUri
    const postValidationCode= props.postValidationCode
    

    const [mfaCode, setMfaCode] = useState('')
    const submitHandler = e => {
        e.preventDefault()
        postValidationCode(mfaCode)
    }

    return (

        <YellowRoundedContainer fluid="md">

            <Form autoComplete="off" onSubmit={submitHandler}>
                <Container >

                    <ArticleArea>
                        <h1>{messages.DisplayQrCodeHeader}</h1>
                        <p>{messages.DisplayQrCodeParagraph}</p>
                    </ArticleArea>

                    <BfYellowRowForm>
                        <QRCodeCanvas
                            id="qrCode"
                            value={url}
                            size={400}
                            bgColor={"#ffffff"}
                            level={"H"}
                        />
                    </BfYellowRowForm>

                    <BfTightYellowRowForm />
                    <BfTightYellowRowForm />

                    <BfYellowRowForm>
                        <Col xs={12} md={12}>
                            <Form.Group controlId="formHorizontalmfaCode">
                                
                                <BfFormLabel>{messages.Kode}</BfFormLabel>

                                <BfFormControl
                                    className="col-md2"
                                    type="input"
                                    placeholder=""
                                    name="mfacode"
                                    value={mfaCode}
                                    onChange={(event) => setMfaCode(event.target.value)}
                                />
                                
                            </Form.Group>
                        </Col>
                    </BfYellowRowForm>

                    <BfTightYellowRowForm>
                        <Col xs={12} md={12}>
                            <BfButtonBlue variant="primary" type="submit" disabled={!mfaCode}>
                                {messages.SendKode}
                            </BfButtonBlue>
                        </Col>
                    </BfTightYellowRowForm>

                    <BfTightYellowRowForm />

                </Container>

            </Form>


        </YellowRoundedContainer>




    )
}